import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { R400, N500 } from '@atlaskit/theme/colors';
import LockIcon from '@atlaskit/icon/glyph/lock-filled';
import Button from '@atlaskit/button';
import { Frame } from '../Frame';
import { IconAndTitleLayout } from '../IconAndTitleLayout';
import { AKIconWrapper } from '../Icon';
import { messages } from '../../../messages';
import { FormattedMessage } from 'react-intl-next';
import { IconStyledButton } from '../styled';
import Lozenge from '@atlaskit/lozenge';
import { LozengeWrapper } from '../IconAndTitleLayout/styled';
import withFrameStyleControl from '../utils/withFrameStyleControl';
import { HoverCard } from '../../HoverCard';
const FallbackForbiddenIcon = /*#__PURE__*/React.createElement(AKIconWrapper, null, /*#__PURE__*/React.createElement(LockIcon, {
  label: "error",
  size: "small",
  primaryColor: `var(--ds-icon-danger, ${R400})`,
  testId: "forbidden-view-fallback-icon"
}));
export class InlineCardForbiddenView extends React.Component {
  constructor(...args) {
    var _this$props, _this$props$requestAc;
    super(...args);
    _defineProperty(this, "frameRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "state", {
      hasRequestAccessContextMessage: !!((_this$props = this.props) !== null && _this$props !== void 0 && (_this$props$requestAc = _this$props.requestAccessContext) !== null && _this$props$requestAc !== void 0 && _this$props$requestAc.callToActionMessageKey)
    });
    _defineProperty(this, "handleRetry", event => {
      const {
        onAuthorise
      } = this.props;
      event.preventDefault();
      event.stopPropagation();
      if (onAuthorise) {
        onAuthorise();
      } else {
        var _this$props2, _this$props2$requestA, _this$props2$requestA2;
        (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$requestA = _this$props2.requestAccessContext) === null || _this$props2$requestA === void 0 ? void 0 : (_this$props2$requestA2 = _this$props2$requestA.action) === null || _this$props2$requestA2 === void 0 ? void 0 : _this$props2$requestA2.promise();
      }
    });
    _defineProperty(this, "renderForbiddenAccessMessage", () => {
      var _this$props3, _this$props3$requestA;
      if ((_this$props3 = this.props) !== null && _this$props3 !== void 0 && (_this$props3$requestA = _this$props3.requestAccessContext) !== null && _this$props3$requestA !== void 0 && _this$props3$requestA.callToActionMessageKey) {
        const {
          callToActionMessageKey
        } = this.props.requestAccessContext;
        return /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages[callToActionMessageKey], {
          values: {
            product: this.props.context
          }
        }));
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.invalid_permissions, formattedMessage => {
        return /*#__PURE__*/React.createElement(React.Fragment, null, formattedMessage);
      }));
    });
    _defineProperty(this, "renderActionButton", () => {
      var _this$props$requestAc2;
      const {
        onAuthorise
      } = this.props;
      const ActionButton = withFrameStyleControl(Button, this.frameRef);
      const accessType = (_this$props$requestAc2 = this.props.requestAccessContext) === null || _this$props$requestAc2 === void 0 ? void 0 : _this$props$requestAc2.accessType;
      if (this.state.hasRequestAccessContextMessage) {
        return /*#__PURE__*/React.createElement(ActionButton, {
          spacing: "none",
          onClick: this.handleRetry,
          component: IconStyledButton,
          testId: "button-connect-other-account",
          role: "button",
          isDisabled: accessType === 'PENDING_REQUEST_EXISTS'
        }, this.renderForbiddenAccessMessage());
      }
      if (onAuthorise) {
        return /*#__PURE__*/React.createElement(Button, {
          spacing: "none",
          onClick: this.handleRetry,
          appearance: "subtle-link",
          testId: "button-connect-other-account",
          role: "button"
        }, /*#__PURE__*/React.createElement(LozengeWrapper, null, /*#__PURE__*/React.createElement(Lozenge, {
          appearance: 'moved'
        }, this.renderForbiddenAccessMessage())));
      }
      return null;
    });
  }
  render() {
    const {
      url,
      icon,
      onClick,
      isSelected,
      testId = 'inline-card-forbidden-view',
      truncateInline
    } = this.props;
    const content = /*#__PURE__*/React.createElement(Frame, {
      testId: testId,
      isSelected: isSelected,
      ref: this.frameRef,
      truncateInline: truncateInline
    }, /*#__PURE__*/React.createElement(IconAndTitleLayout, {
      icon: icon ? icon : FallbackForbiddenIcon,
      link: url,
      title: url,
      onClick: onClick,
      titleColor: `var(--ds-text-subtle, ${N500})`
    }), this.renderActionButton());
    if (this.props.showHoverPreview) {
      return /*#__PURE__*/React.createElement(HoverCard, {
        url: url
      }, content);
    }
    return content;
  }
}